import React from 'react'
import Select, { ActionMeta, SingleValue } from 'react-select'

interface Props {
   Width?: string | number,
   value?: {
    label: string,
    value: string
    } | null,
   options?: {
       label: string,
       value: string
   }[],
   placeholder?: string,
   isClearable?: boolean,
   isSearchable?: boolean,
   color?: string,
   loading?: boolean,
   onChange?: ((newValue: SingleValue<{
    label: string;
    value: string;
}>, actionMeta: ActionMeta<{
    label: string;
    value: string;
}>) => void) | undefined,
disabled?: boolean,
fontColor?: string 
}

export const Picker: React.FC<Props> = ({Width,isClearable,isSearchable, fontColor, value,options, disabled, placeholder, color, loading, onChange}) => {
    return (
    <Select 
        value={value && value}
        options={options}
        isLoading={loading}
        onChange={onChange}
        isDisabled={disabled}
        isClearable={isClearable}
        isSearchable={isSearchable}
        isRtl={true}
        placeholder={placeholder}
        styles={{
            
            control: styles => ({ ...styles, width: Width ? Width : 255, backgroundColor: color? color : '#1D252D', padding: 5, border: 0, borderRadius: 5, fontSize: 13, marginTop: 5, marginBottom: 5}),
            input: styles => ({...styles, fontSize: 13, "::placeholder": {color: 'red'}}),
            option: styles => ({...styles, fontSize: 13}),
            menu: styles => ({...styles, overflow: 'auto', margin: 0, padding: 0}),
            singleValue: styles => ({...styles, color: fontColor ? fontColor : '#fff', fontWeight: 'bold'})
            }}
            theme={theme => ({
                ...theme,
                borderRadius: 0,
                colors: {
                ...theme.colors,
                primary25: 'wheat',
                primary: '#494D60',
                },
            })}
    />)
}